const initialState = {
    dataIndustrySelectable: []
}

const industryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_INDUSTRY_SELECTABLE':
            return {
                ...state,
                dataIndustrySelectable: action.payload
            }
        default:
            return state
    }
}

export default industryReducer
